import script from "./SubscriptionExpired.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionExpired.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionExpired.vue?vue&type=style&index=0&id=32c7bb10&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c7bb10"]])

export default __exports__